import { componentStyles } from "./tag.scss";
import Colors from "/styles/colors";
import { getViIcon } from "segments/desktop/homepage-first-fold/layouts/monday-products-homepage-first-fold/consts";
import { BRAND_BLACK_TEXT_COLOR } from "styles/color-consts";

function Tag({ text, invertColors, cardMainColor, productType }) {
  const TEXT_PADDING_BOTTOM = 3;
  const tagStyles = invertColors
    ? {
        color: Colors[BRAND_BLACK_TEXT_COLOR],
        borderColor: "transparent"
      }
    : { borderColor: Colors[cardMainColor], color: Colors[cardMainColor], padding: "4px 8px" };

  return (
    <div className="tag" style={tagStyles}>
      {invertColors && getViIcon(productType)}
      <div className="tag-text" style={{ paddingBottom: invertColors ? `${TEXT_PADDING_BOTTOM}px` : 0 }}>
        {text}
      </div>
      <style jsx>{componentStyles}</style>
    </div>
  );
}

export default Tag;
